import jsPDF from "jspdf";
import 'jspdf-autotable';
import { formatDate } from "./Date&TimeUtils";
import { logoImg } from "./LogoImgUtils";
const generateTimeTrackingPDF = (timeTrackingMonthData,userEmail:string) => {
    const doc = new jsPDF();  
    const startDate = timeTrackingMonthData[timeTrackingMonthData.length-1]?.date
    const endDate = timeTrackingMonthData[0]?.date
    doc.setFontSize(12);
    doc.text(`User: ${userEmail}`, 14, 10);
    doc.text(`Start Date: ${startDate}`, 14, 20);
    doc.text(`End Date: ${endDate}`, 14, 30);
    const table = document.getElementById('table1');
    const rows = table?.querySelectorAll('tr');
    const tableData = [];
    const tableHeaders = [];
    if(rows){
    const headers = rows[0].querySelectorAll('th');
    headers.forEach(header => {
      tableHeaders.push(header.innerText);
    });
    rows.forEach((row, rowIndex) => {
      if (rowIndex > 0) { // Skip the header row
        const rowData = [];
        const cells = row.querySelectorAll('td');
        cells.forEach(cell => {
          rowData.push(cell.innerText);
        });
        tableData.push(rowData);
      }
    });
    doc.autoTable({
        head: [tableHeaders],
        body: tableData,
        startY: 40,
      });
    
   doc.save(`${userEmail} ${endDate} Time Records.pdf`);}
  };
  export default generateTimeTrackingPDF;

  export const generateTimeOffRequestsPDF = (timeTrackingMonthData,userEmail:string) => {
    const doc = new jsPDF();  
    var startDate = timeTrackingMonthData[timeTrackingMonthData.length-1]?.date
   var endDate = timeTrackingMonthData[0]?.date
    if(startDate&&endDate){
      startDate = formatDate(startDate,'DD MMM, YY')
       endDate = formatDate(endDate,'DD MMM, YY')}
    doc.setFontSize(12);
    doc.text(`User: ${userEmail}`, 14, 10);
    doc.text(`Start Date: ${startDate}`, 14, 20);
    doc.text(`End Date: ${endDate}`, 14, 30);
    const table = document.getElementById('table2');
    const rows = table?.querySelectorAll('tr');
    const tableData = [];
    const tableHeaders = [];
    if(rows){
    const headers = rows[0].querySelectorAll('th');
    headers.forEach(header => {
      tableHeaders.push(header.innerText);
    });
    rows.forEach((row, rowIndex) => {
      if (rowIndex > 0) { // Skip the header row
        const rowData = [];
        const cells = row.querySelectorAll('td');
        cells.forEach(cell => {
          rowData.push(cell.innerText);
        });
        tableData.push(rowData);
      }
    });
    doc.autoTable({
        head: [tableHeaders],
        body: tableData,
        startY: 40,
      });
    
   doc.save(`${userEmail} Time Off Requests.pdf`);
    }
  };

 
  export const userExperienceLetter = (userName, joiningDate, resigningDate, role) => {
    const doc = new jsPDF();
    const leftMargin = 14; 
    const rightMargin = 14; 
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = pageWidth - leftMargin - rightMargin; 
  
   
    doc.addImage(logoImg, 'PNG', leftMargin, 8, 70, 33);
  
    
    doc.setFont('helvetica');
    doc.setFontSize(14);
    doc.setTextColor(0, 102, 204);
  
    
    const title = "TO WHOM IT MAY CONCERN";
    const titleX = (pageWidth - doc.getTextWidth(title)) / 2; 
    doc.text(title, titleX, 50); 
  
    
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0); 
    doc.text(doc.splitTextToSize(`This is to certify that Mr. ${userName} was employed with Sortup as an ${role} from ${joiningDate} to ${resigningDate}.`, textWidth), leftMargin, 70);
  
    
    const bullet = '\u2022'; 
    const bulletSpacing = 7; 
  
    let responsibilities = [];
    switch(role) {
      case 'Software Engineer':
        responsibilities = [
          "Designing, developing, and maintaining software applications and systems.",
          "Writing clean, efficient, and well-documented code.",
          "Collaborating with cross-functional teams to define, design, and ship new features.",
          "Debugging and troubleshooting issues in existing applications.",
          "Continuously improving and updating technical knowledge and skills."
        ];
        break;
      case 'Team Lead':
        responsibilities = [
          "Leading a team of software engineers in designing and developing applications.",
          "Coordinating with project managers and stakeholders to ensure timely delivery of projects.",
          "Conducting code reviews and mentoring junior developers.",
          "Managing team resources and schedules.",
          "Facilitating team meetings and discussions."
        ];
        break;
      case 'Manager':
        responsibilities = [
          "Overseeing the development and implementation of company projects.",
          "Managing project timelines, budgets, and resources.",
          "Collaborating with different departments to ensure project alignment.",
          "Evaluating team performance and providing feedback.",
          "Developing strategies to improve productivity and efficiency."
        ];
        break;
      case 'HR':
        responsibilities = [
          "Managing recruitment and hiring processes.",
          "Developing and implementing HR policies and procedures.",
          "Handling employee relations and resolving conflicts.",
          "Conducting performance reviews and employee training.",
          "Ensuring compliance with labor laws and regulations."
        ];
        break;
      default:
        responsibilities = [];
    }
  
    let currentY = 90;
    responsibilities.forEach(responsibility => {
      doc.text(doc.splitTextToSize(`${bullet} ${responsibility}`, textWidth), leftMargin, currentY);
      currentY += bulletSpacing; 
    });
  
    
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(doc.splitTextToSize(`Mr. ${userName} demonstrated excellent technical skills, a strong work ethic, and a keen ability to solve complex problems.`, textWidth), leftMargin, currentY + 10);
    doc.text(doc.splitTextToSize("He was proactive in identifying areas for improvement and took the initiative to implement effective solutions.", textWidth), leftMargin, currentY + 30);
    doc.text(doc.splitTextToSize("His contribution was valuable to the team and the company as a whole.", textWidth), leftMargin, currentY + 40);
    doc.text(doc.splitTextToSize(`We found Mr. ${userName} to be a dedicated and reliable professional who consistently delivered high-quality work.`, textWidth), leftMargin, currentY + 50);
    doc.text(doc.splitTextToSize("He has a positive attitude, good communication skills, and the ability to work well under pressure.", textWidth), leftMargin, currentY + 60);
  
 
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0); 
    doc.text(doc.splitTextToSize("For any further inquiries regarding the employment, please contact us at contact@sortup.dev", textWidth), leftMargin, currentY + 80);
    doc.text(doc.splitTextToSize("Regards,", textWidth), leftMargin, currentY + 90);
    doc.text(doc.splitTextToSize("______________________", textWidth), leftMargin, currentY + 100);
    doc.text(doc.splitTextToSize("Sheharyar Shahid", textWidth), leftMargin, currentY + 110);
    doc.setTextColor(0, 102, 204); 
    doc.text(doc.splitTextToSize("Co-Founder, Sortup", textWidth), leftMargin, currentY + 120);
  
   
    doc.save(`${userName} Experience Letter.pdf`);
  };